import { mountIsland } from "../../lib/mount";
import { ContactForm } from "./ContactForm";

mountIsland("contact-form", ContactForm);
